import {
  hideLoader,
  showLoader,
} from '../../commonComponents/Loader/loader.actions';
import {Network} from '../network';
import {commonReduxActionTypes} from './commonRedux.actionTypes';
//import {Network} from '../../utils/network';

export const getConfig = (params) => async (dispatch, state) => {
  try {
    const res = await Network.getConfig(params);
    if (res?.data) {
      dispatch({
        type: commonReduxActionTypes.GET_CONFIG,
        payload: res.data,
      });
    }
  } catch (e) {}
};

export const setLoginVisibility = data => async (dispatch, state) => {
  try {
    dispatch({
      type: commonReduxActionTypes.IS_LOGIN_MODAL_SHOW,
      payload: data,
    });
  } catch (e) {}
};

export const setLoaderVisibility = data => async (dispatch, state) => {
  try {
    if (data) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  } catch (e) {}
};

export const getFAQ = () => async (dispatch, state) => {
  try {
    const res = await Network.getFaqs();
    if (res?.data && res?.data?.success) {
      dispatch({
        type: commonReduxActionTypes.GET_FAQ,
        payload: res.data?.data,
      });
    }
  } catch (e) {}
};

export const setIsLogin = status => async (dispatch, state) => {
  dispatch({
    type: commonReduxActionTypes.SET_IS_LOGIN,
    payload: status,
  });
};

export const setAppPaused = () => ({
  type: commonReduxActionTypes.SET_APP_PAUSED,
});

export const setAppResumed = () => ({
  type: commonReduxActionTypes.SET_APP_RESUMED,
});

export const setInitialDynamicLinkFired = () => ({
  type: commonReduxActionTypes.SET_INITIAL_DYNAMIC_LINK,
});
